/* eslint-disable @typescript-eslint/no-explicit-any */
import { isPrimitive } from '@core/helpers';
import { Injectable } from '@rxdi/core';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable()
export class LocalStorageService {
  private updateQueue: Subject<{ name: string; data: unknown }> = new Subject();
  get<T>(name: string): T {
    const item = localStorage.getItem(name);
    try {
      return JSON.parse(item);
    } catch (e) {
      return item as never;
    }
  }

  update(name: string, payload: any) {
    const data = isPrimitive(payload) ? payload : JSON.stringify(payload);
    localStorage.setItem(name, data);
    this.updateQueue.next({ name, data });
  }

  onUpdated(name: string) {
    return this.updateQueue.pipe(filter((data) => data.name === name));
  }

  clear() {
    localStorage.clear();
  }

  remove(name: string) {
    localStorage.removeItem(name);
  }
}
